import { AbstractControl, ValidationErrors } from "@angular/forms";
import { RegexConstants } from "../constants/regex.constants";

export class CustomValidators {

    static emailValidtor(control: AbstractControl): ValidationErrors | null {
        if (!control.value) return null;
        return RegexConstants.EMAIL.test(control.value)
            ? null
            : { emailInValid: true };
    }

    static numberOnlyValidator(control: AbstractControl): ValidationErrors | null {
        if (!control.value) return null;
        return RegexConstants.NUMBER_ONLY.test(control.value)
            ? null
            : { numberInvalid: true };
    }

    static alphabetOnlyValidator(control: AbstractControl): ValidationErrors | null {
        if (!control.value) return null;
        return RegexConstants.ALPHABET_ONLY.test(control.value)
            ? null
            : { alphabetInvalid: true };
    }

    static phoneValidator(control: AbstractControl): ValidationErrors | null {
        if (!control.value) return null;
        return RegexConstants.PHONE.test(control.value)
            ? null
            : { phoneInvalid: true };
    }

    static phoneTNValidator(control: AbstractControl): ValidationErrors | null {
        if (!control.value) return null;
        return RegexConstants.PHONE_TN.test(control.value)
            ? null
            : { phoneTNInvalid: true };
    }

static cnamCodeValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;

    return RegexConstants.CNAM_CODE.test(control.value)
        ? null
        : { cnamCodeInvalid: true };
}
static doctorRefValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
        return null;
    }

    return RegexConstants.DOCTOR_REF.test(control.value)
        ? null
        : { doctorRefInvalid: true };
}
}